export enum WillemWagtailPageType {
  root = 'willem.WillemRootPage',
  work = 'willem.Work',
  project = 'willem.Project',
  home = 'willem.WillemHomePage',
  contact = 'willem.ContactPage',
  bureau = 'willem.Bureau',
}
